<template>
  <ul class="Tree">
    <tree-node
      v-for="actor in currentLandscape.actors"
      :key="actor._id"
      :actor="actor"
      :level="0"
    />
    <new-actor-button
      v-show="!selectedActor"
      v-if="hasManagerRights"
      class="NewActorRoot-button"
      :root="!selectedActor"
      :level-depth="0"
      :level-width="currentLandscape.actors.length"
      :color="newActorColor"
    />
  </ul>
</template>

<script>
import {mapGetters} from 'vuex'
import TreeNode from './TreeNode'
import NewActorButton from './NewActorButton'
import gsap from 'gsap'

export default {
  name: 'Tree',
  components: {
    NewActorButton,
    TreeNode
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters(['currentLandscape', 'selectedActor', 'hasManagerRights']),
    newActorColor() {
      return `color${this.currentLandscape.actors.length}`
    }
  },
  watch: {
    currentLandscape(newValue, oldValue) {
      if (newValue._id !== oldValue._id) {
        gsap.to('.Tree', 0.8, {
          opacity: 1,
          startAt: {opacity: 0},
          ease: 'power3.in'
        })
      }
    }
  }
}
</script>

<style>
.Tree {
  margin: 0 0 32px 32px;
  padding-top: 24px;
  border-left: 2px solid theme('colors.gray.300');
  .NewActorRoot-button {
    margin-top: 32px;
    margin-left: -9px;
  }
  @media (--desktop) {
    padding-top: 32px;
  }
}
</style>
